"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BqQueryReplacerVisitor = void 0;
const _1 = require(".");
const sheet_db_1 = require("../../../sheet_db");
const map_utils_1 = require("../../../utils/map.utils");
class BqQueryReplacerVisitor extends _1.VisitorBase {
    colsMap;
    constructor(columns) {
        super();
        this.colsMap = map_utils_1.MapUtils.arrayToMap(columns, 'name');
    }
    // this will translate old names to new names
    visitColumn(node) {
        if (node.isPlanVariable())
            return;
        const originalColumn = this.colsMap.get(node.cleanedToken);
        if (!originalColumn)
            return;
        const queryReplacer = BqQueryReplacerVisitor.getQueryReplacer(originalColumn.type);
        node.queryReplacer = queryReplacer;
    }
    static getQueryReplacer(type) {
        const selectId = (id) => `\`${id.slice(1, id.length - 1)}\``;
        return (id) => (0, sheet_db_1.getBqQueryReplacer)(type)(selectId(id));
    }
}
exports.BqQueryReplacerVisitor = BqQueryReplacerVisitor;
